import { createContext } from "react";
import { populateArray } from "./functions";

export const Reducer = (state, action) => {
    switch (action.type) {
        case "SET_STEP":
            return {
                ...state,
                step: action.step,
            };

        case "STEP_BACK":
            return {
                ...state,
                step: state.step > 1 ? state.step - 1 : 1,
            };
        case "STEP_FORWARD":
            return {
                ...state,
                step: state.step < state.steps ? state.step + 1 : state.steps,
            };

        case "SET_LOADING":
            return {
                ...state,
                isLoading: action.isLoading,
            };

        case "ADD_DATA":
            return { ...state, ...action.payload };

        case "UPDATE_FILES":
            return { ...state, files: action.files };

        case "INIT_COMPANIES":
            const company = state.templates.company;
            const companies = populateArray(state.values.companies, action.count || 1, company);

            return {
                ...state,
                ...{
                    values: {
                        ...state.values,
                        ...{ companies },
                    },
                },
            };

        case "INIT_INDIVIDUALS":
            const individual = state.templates.individual;
            const individuals = populateArray(
                state.values.individuals,
                action.count || 1,
                individual
            );

            return {
                ...state,
                ...{
                    values: {
                        ...state.values,
                        ...{ individuals },
                    },
                },
            };

        case "SET_ERROR":
            return {
                ...state,
                error: action.error,
            };
        default:
            return state;
    }
};

export const initialState = {
    steps: 5,
    step: 1,
    isLegalEntity: true,
    fundOption: 1,
    fundTitle: "",
    error: null,
    files: [],
    templates: {
        company: {
            type: "Rechtspersoon",
            rechtsvorm: "",
            rechtsvormAndere: "",
            naam: "",
            btwNumber: "",
            straat: "",
            huisnummer: "",
            bus: "",
            postcode: "",
            gemeente: "",
            land: "België",
            voornaam: "",
            telefoonnummer: "",
            emailadres: "",
            rijksregisternummer: "",
            geboorteplaats: "",
            geboorteland: "",
            legalRepresentatives: [
                {
                    type: "",
                    entityName: "",
                    btwNumber: "",
                    naam: "",
                    voornaam: "",
                    straat: "",
                    huisnummer: "",
                    bus: "",
                    gemeente: "",
                    postcode: "",
                    land: "België",
                    telefoonnummer: "",
                    emailadres: "",
                    rijksregisternummer: "",
                    geboorteplaats: "",
                    geboorteland: "België",
                    isUBOMaatschap: "",
                    maatDeMaatschapVertegenwoordigen: "",
                },
            ],
        },
        individual: {
            naam: "",
            voornaam: "",
            straat: "",
            huisnummer: "",
            bus: "",
            gemeente: "",
            postcode: "",
            land: "België",
            telefoonnummer: "",
            emailadres: "",
            rijksregisternummer: "",
            geboorteplaats: "",
            geboorteland: "België",
            huwelijksgemeenschapVerbinden: "",
            onverdeeldheidVertegenwoordigen: "",
        },
    },
    values: {
        individualsCount: 2,
        companiesCount: 2,
        maatschap: {
            naam: "",
            btwNummer: "",
            land: "België",
            straat: "",
            huisnummer: "",
            bus: "",
            postcode: "",
            gemeente: "",
        },
        companies: [],
        individuals: [],
        files: {},
        uploads: {},
        fund_commitment: "",
        fund_iBan: "",
        gdpr: false,
    },
};

export const Context = createContext(initialState);
